import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Button } from 'web-ui-components/lib/atoms/buttons';

const ContinueFooterBar = ({ showFooter, onContinue, disableContinue }) => {
	const payeeFooterClassName = classNames('c-m-payee-footer-bar', {
		'c-m-payee-footer-bar--is-visible': showFooter,
	});
	return (
		<div data-cy="payee-footer-bar" className={payeeFooterClassName}>
			<div className="container container--lg">
				<div className="c-m-payee-footer-bar__wrap">
					<div className="c-m-payee-footer-bar__column c-m-payee-footer-bar__column--summary">
						<Button display="primary" size="md" width="flush" onClick={onContinue} disabled={disableContinue}>
							<span className="c-a-button__title">Continue</span>
						</Button>
					</div>
				</div>
			</div>
		</div>
	);
};

ContinueFooterBar.propTypes = {
	showFooter: PropTypes.bool.isRequired,
	disableContinue: PropTypes.bool,
	onContinue: PropTypes.func.isRequired,
};

export default ContinueFooterBar;
